import './index.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSign, MapPin } from 'react-feather';
import { LoungeResource } from '../../../../store/lounges/loungesManagementTypes';

type PropsTypes = {
  lounge: LoungeResource;
};

const BookLoungeDetails = (props: PropsTypes) => {
  const { t } = useTranslation();
  const loungePrice = t('LOUNGE_PRICE_TEXT', {
    bookingPrice: props.lounge.bookingPrice,
  });

  return (
    <div className="book-lounge-form-details">
      <div className="book-lounge-form-detail-item">
        <div className="book-lounge-form-detail-item-icon">
          <DollarSign size={18} />
        </div>
        <div className="book-lounge-form-detail-item-price">{loungePrice}</div>
      </div>
      <div className="book-lounge-form-detail-item">
        <div className="book-lounge-form-detail-item-icon">
          <MapPin size={18} />
        </div>
        <div className="book-lounge-form-detail-item-location">
          {/*<div className="book-lounge-form-detail-item-location-name">*/}
          {/*  {props.lounge.building?.location?.name}*/}
          {/*</div>*/}
          <div className="book-lounge-form-detail-item-location-building">
            {props.lounge.building?.name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookLoungeDetails;
